// CodeSuggestionBar.js
// AI code suggestion bar for Monaco editor
import React, { useState } from 'react';

const CodeSuggestionBar = ({ onAccept, onReject, suggestion }) => {
  if (!suggestion) return null;
  return (
    <div style={{
      position: 'absolute',
      bottom: 44,
      left: 0,
      right: 0,
      background: '#232323',
      color: '#fff',
      borderTop: '1px solid #6366f1',
      padding: '10px 24px',
      display: 'flex',
      alignItems: 'center',
      zIndex: 1100,
      fontSize: 15,
      boxShadow: '0 2px 12px #0003',
    }}>
      <span style={{ flex: 1 }}><strong>AI Suggestion:</strong> {suggestion}</span>
      <button onClick={onAccept} style={{ marginLeft: 16, background: '#2ecc40', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 16px', fontWeight: 500, cursor: 'pointer' }}>Accept</button>
      <button onClick={onReject} style={{ marginLeft: 8, background: '#e74c3c', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 16px', fontWeight: 500, cursor: 'pointer' }}>Reject</button>
    </div>
  );
};

export default CodeSuggestionBar;
